import { RouterProvider } from "react-router-dom";
import { router } from "./routes";
import React, { Suspense } from "react";
import { Center, Spinner } from "@chakra-ui/react";
function App() {
  localStorage.setItem("chakra-ui-color-mode", "light");

  return (
    <Suspense
      fallback={
        <Center h="100vh">
          <Spinner size="xl" color="teal" />
        </Center>
      }
    >
      <RouterProvider router={router} />
    </Suspense>
  );
}

export default App;
